<div class="grid grid-cols-3 gap-4">
  <div class="col-span-2 grid grid-cols-3 gap-2">
    <div class="text-center dark:text-white font-bold uppercase">Denominacion</div>
    <div class="text-center dark:text-white font-bold uppercase">Cantidad</div>
    <div class="text-center dark:text-white font-bold uppercase">Total</div>

    <div *ngFor="let denominacion of denominacionFormato" class="col-span-3 grid grid-cols-3 gap-4">
      <input style="margin: 0px;"
        class="bg-gray-200 border rounded border-gray-300 placeholder-gray-500 py-1 font-bold text-base dark:border-gray-600 dark:bg-slate-800 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray form-input text-center"
        disabled value="{{ denominacion.cantidad | number }}" id="monto-{{denominacion.id}}" type="text">

      <input style="margin: 0px;" id="cantidad-{{denominacion.id}}"  [name]="denominacion.id" disabled
        class="montoUF border rounded border-gray-300 placeholder-gray-500 py-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray form-input text-center"
        type="number" inputmode="numeric" min="0">

      <input style="margin: 0px;"  id="total-{{denominacion.id}}"
        class="bg-gray-200 border rounded border-gray-300 placeholder-gray-500 py-1 text-sm dark:border-gray-600 dark:bg-slate-800 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray form-input text-center"
        disabled type="text">
    </div>

  </div>
  <div class="grid grid-cols-1 gap-4">
    <div style="padding: 5pt;">
      <br>
      <div class="w-full text-center text-black dark:text-white" style="font-size: 30pt;">{{carril}}<br>{{fondoInicial}}</div>
      <input type="button" *ngIf="tieneFondoAsignado===true"  value="Confirmar" (click)="confirmarFondoInicial()" class="w-full btn-success">
    </div>
  </div>
</div>
